// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SiteIcons/listSeaechIcon.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageReservation-panelHeader-fkrQi {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  border-bottom: 1px solid var(--primary-border);
  background: var(--background-primary);
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.ManageReservation-listFlex-zwWVV {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  margin: 30px 0;
}

.ManageReservation-formControlInput-Nk_3G {
  width: 382px;
  height: 45px;
  border: 1px solid var(--primary-border);
  border-radius: 23px;
}

.ManageReservation-searchReservationInput-ToeZB {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  padding-left: 35px;
  background-size: 15px;
  background-position: 15px 50%;
}

.ManageReservation-linkCss-kHb9l {
  background-color: transparent !important;
  border: 1px solid var(--primary-border) !important;
  padding: 12px 20px !important;
  border-radius: 23px !important;
  color: var(--primary-foreground) !important;
  font-size: 16px;
  -webkit-box-shadow: inherit !important;
          box-shadow: inherit !important;
}

.ManageReservation-linkCssActive-jea5v {
  background-color: var(--secondary-bg) !important;
  border: 1px solid var(--secondary-bg) !important;
  color: var(--common-primary-white-foreground) !important;
  padding: 12px 20px !important;
  border-radius: 23px !important;
  -webkit-box-shadow: inherit !important;
          box-shadow: inherit !important;
  font-size: 16px;
}

.ManageReservation-linkCssActive-jea5v img {
  -webkit-filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);
          filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);
}

.ManageReservation-plusIcon-RmLcL {
  margin-right: 6px;
}

.ManageReservation-noMargin-yeJp_ {
  margin: 0;
}

@media screen and (max-width: 767px) {
  .ManageReservation-formControlInput-Nk_3G {
    width: 100%;
  }

  .ManageReservation-listFlex-zwWVV {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-top: 15px;
    margin-bottom: 15px;
    row-gap: 15px;
  }

  .ManageReservation-mobileSearchWidth-_7iYX {
    width: 100%;
  }

  .ManageReservation-linkCss-kHb9l {
    display: block;
    text-align: center;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/ManageReservation/ManageReservation.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,mDAA+D;EAC/D,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;EAClD,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;EAC3C,eAAe;EACf,sCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;EAChD,gDAAgD;EAChD,wDAAwD;EACxD,6BAA6B;EAC7B,8BAA8B;EAC9B,sCAA8B;UAA9B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,sGAA8F;UAA9F,8FAA8F;AAChG;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,mBAAe;QAAf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;AAEF","sourcesContent":[".panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  border-bottom: 1px solid var(--primary-border);\n  background: var(--background-primary);\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.listFlex {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 30px 0;\n}\n\n.formControlInput {\n  width: 382px;\n  height: 45px;\n  border: 1px solid var(--primary-border);\n  border-radius: 23px;\n}\n\n.searchReservationInput {\n  background: url('../../../public/SiteIcons/listSeaechIcon.svg');\n  background-repeat: no-repeat;\n  padding-left: 35px;\n  background-size: 15px;\n  background-position: 15px 50%;\n}\n\n.linkCss {\n  background-color: transparent !important;\n  border: 1px solid var(--primary-border) !important;\n  padding: 12px 20px !important;\n  border-radius: 23px !important;\n  color: var(--primary-foreground) !important;\n  font-size: 16px;\n  box-shadow: inherit !important;\n}\n\n.linkCssActive {\n  background-color: var(--secondary-bg) !important;\n  border: 1px solid var(--secondary-bg) !important;\n  color: var(--common-primary-white-foreground) !important;\n  padding: 12px 20px !important;\n  border-radius: 23px !important;\n  box-shadow: inherit !important;\n  font-size: 16px;\n}\n\n.linkCssActive img {\n  filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);\n}\n\n.plusIcon {\n  margin-right: 6px;\n}\n\n.noMargin {\n  margin: 0;\n}\n\n@media screen and (max-width: 767px) {\n  .formControlInput {\n    width: 100%;\n  }\n\n  .listFlex {\n    flex-wrap: wrap;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    row-gap: 15px;\n  }\n\n  .mobileSearchWidth {\n    width: 100%;\n  }\n\n  .linkCss {\n    display: block;\n    text-align: center;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelHeader": `ManageReservation-panelHeader-fkrQi`,
	"listFlex": `ManageReservation-listFlex-zwWVV`,
	"formControlInput": `ManageReservation-formControlInput-Nk_3G`,
	"searchReservationInput": `ManageReservation-searchReservationInput-ToeZB`,
	"linkCss": `ManageReservation-linkCss-kHb9l`,
	"linkCssActive": `ManageReservation-linkCssActive-jea5v`,
	"plusIcon": `ManageReservation-plusIcon-RmLcL`,
	"noMargin": `ManageReservation-noMargin-yeJp_`,
	"mobileSearchWidth": `ManageReservation-mobileSearchWidth-_7iYX`
};
module.exports = ___CSS_LOADER_EXPORT___;
